export default "__VITE_ASSET__DwKQsoL9__"